import { Injectable, computed, signal } from '@angular/core';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { GLOBAL_CONSTANT } from '../constants/global.constant';

@Injectable({
  providedIn: 'root',
})
export class LegalLocalizationService {
  private router = inject(Router);

  legalLocalization = signal(true);
  signedUpCountry = signal(GLOBAL_CONSTANT.EMPTY_STRING);

  isUSRoute = computed(() => this.router.url.includes(GLOBAL_CONSTANT.US_REGEX));

  checkForUS(): boolean {
    return this.isUSRoute();
  }
}
